import { Link } from "gatsby";
import styled from "../styled";

export const StyledNavLink = styled(Link)`
    &.active {
        border-bottom: 3px solid var(--secondary-color);
    }
`;
